import { Col, Form, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import AppPageHeader from '@/components/_common/AppPageHeader';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';

import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import { useIntl } from 'react-intl';

const SuppliersSelectedFilters: React.FC<
  ExtraFiltersProps<ListSuppliersQuery>
> = ({ setQueryParams }) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={8}>
            <Col span={12}>
              <Input
                name="cpfCnpj"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, cpfCnpj: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'suppliers.filters.cpfCnpj',
                })}
              />
            </Col>

            <Col span={12}>
              <OrderExtraFilter
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,

                    order: value,
                  }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default SuppliersSelectedFilters;
